/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint jsx-a11y/no-static-element-interactions: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { replace } from 'react-router-redux';
import qs from 'qs';
import { Link, withRouter } from 'react-router';
import {
  Button,
  Checkbox,
  Dimmer,
  Dropdown,
  Grid,
  Header,
  Icon,
  Label,
  Loader,
  Table,
} from 'semantic-ui-react';

import config from '../../config';
import isNumber from '../utils/numbers/isNumber';
import { decodeSearch, encodeSearch } from '../utils/url';
import { BookingDatePicker, BookingSelectList } from './Filters';
import { flashErrorMessage, flashSuccessMessage } from '../actions/flash';
import { fetchM } from '../actions/fetchM';
import PageNav from './PageNav';
import SearchIn from './SearchIn';
import SortButton from './SortButton';
import Timestamp from './Timestamp';
import ModalNotice from '../containers/modals/ModalNotice';
import HimsErrorLog from '../components/HimsErrorLog';
import { HIMS_BOOKING_SYNC_STATUSES } from '../constants/hims';
import { titleCase } from '../utils/strings';

const allFilterNames = [
  'dateRange',
  'dateFrom',
  'dateTo',
  'projectFilter',
  'status',
  'search',
];

class HIMSBookingsList extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    where: PropTypes.shape({}),
    onLoading: PropTypes.func,
    noScrollTop: PropTypes.bool,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
  }
  static getPropsToState = (props) => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const limit = 30;
    const offset = (currentPage - 1) * limit;
    const search = query.search || '';
    const searchIn = query.searchIn || '';
    const dateRange = query.dateRange || '';
    const projectFilter = query.projectFilter || '';
    const dateFrom = query.dateFrom ? query.dateFrom : '';
    const dateTo = query.dateTo ? query.dateTo : '';
    const loadingProjectSearch = false;
    const findProjectResults = [];
    const status = query.status || '';
    return {
      isMobile,
      search,
      searchIn,
      dateRange,
      projectFilter,
      dateTo,
      dateFrom,
      loadingProjectSearch,
      findProjectResults,
      currentPage,
      limit,
      offset,
      status,
    };
  }
  constructor(props) {
    super(props);
    const state = HIMSBookingsList.getPropsToState(props);
    const shiftSelect = { start: null, end: null };
    this.state = {
      loading: true,
      count: 0,
      data: [],
      dataByStatus: [],
      ...state,
      isChanging: false,
      projectOpts: [],
      filteredProjects: [],
      shiftSelect,
      errorModalOpen: false,
      isSelectedAll: false,
      himsErrorLog: null,
    };
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    this.fetchProjects();
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    this.replaceQuery(query);
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = HIMSBookingsList.getPropsToState(nextProps);
    this.setState(state);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  handleCloseErrorModal = (e) => {
    e.preventDefault();
    this.setState({ errorModalOpen: false, himsErrorLog: null });
  }
  handleOpenErrorModal = (e, himsErrorLog) => {
    e.preventDefault();
    this.setState({ errorModalOpen: true, himsErrorLog });
  }
  handleCheckboxClick = (event, b) => {
    const { shiftSelect, data } = this.state;
    const index = data.findIndex(r => r.id === b.id);
    if (event.shiftKey) {
      if (data[shiftSelect.start].isSelected !== data[index].isSelected) {
        shiftSelect.end = null;
      }
      if (shiftSelect.start === null) {
        shiftSelect.start = index;
      }
      if (shiftSelect.start !== index) {
        if (shiftSelect.start > index) {
          data.forEach((d, idx) => {
            if (this.isBookingSelectable(d)) {
              if (idx >= index && idx <= shiftSelect.start) {
                data[idx].isSelected = data[shiftSelect.start].isSelected;
              }
              if (shiftSelect.end && idx >= shiftSelect.end && idx <= index) {
                data[idx].isSelected = !data[shiftSelect.start].isSelected;
              }
            }
          });
        }
        if (shiftSelect.start < index) {
          data.forEach((d, idx) => {
            if (this.isBookingSelectable(d)) {
              if (idx >= shiftSelect.start && idx <= index) {
                data[idx].isSelected = data[shiftSelect.start].isSelected;
              }
              if (shiftSelect.end && idx >= index && idx <= shiftSelect.end) {
                data[idx].isSelected = !data[shiftSelect.start].isSelected;
              }
            }
          });
        }
        shiftSelect.end = index;
      } else {
        data[index].isSelected = !data[index].isSelected;
      }
    } else {
      data[index].isSelected = !data[index].isSelected;
      shiftSelect.start = index;
      shiftSelect.end = null;
    }
    this.setState({ shiftSelect, data, isSelectedAll: false });
  }
  isBookingSelectable = (data) => {
    if (data && (!data.himsServiceID || data.himsHasChanges || data.himsServiceStatus === 'failed' || (data.himsServiceErrors && data.himsServiceErrors.length > 0))) {
      return true;
    }
    return false;
  }
  handleCheckboxSelectAll = () => {
    const { shiftSelect, data } = this.state;
    const isSelectedAll = !this.state.isSelectedAll;
    shiftSelect.start = null;
    shiftSelect.end = null;
    data.forEach((d, idx) => {
      if (this.isBookingSelectable(d)) {
        data[idx].isSelected = !this.state.isSelectedAll;
      }
    });
    this.setState({ shiftSelect, data, isSelectedAll });
  }
  getDataByPage = (page, replaceQuery = false) => {
    const { data, limit, status } = this.state;
    let newData = data || [];
    let count = data.length || 0;

    // filter by status
    if (status) {
      const cleanStatus = status.replace('hims-', '');
      newData = newData.filter(b => b.himsServiceStatus === (cleanStatus === 'pending' ? '' : cleanStatus));
      count = newData.length;
    }

    const query = decodeSearch(this.props.location.search);
    const currentPage = parseInt(page, 10);
    const offset = (currentPage - 1) * limit;
    query.page = currentPage;
    newData = newData.slice((page - 1) * limit, page * limit);

    this.setState({ dataByStatus: newData, count, currentPage, offset });
    if (replaceQuery) this.replaceQuery(query);
  }
  setLoadingProjectSearch = (loadingProjectSearch = false) => new Promise((res) => {
    this.setState({ loadingProjectSearch }, res);
  })
  setBookings = (data = []) => new Promise((res) => {
    this.setState({
      data: data || [],
    }, () => {
      res(data);
    });
  })
  setComponentState = (state = {}) => new Promise((res) => {
    this.setState(state, () => {
      res(state);
    });
  })
  setLoading = (loading = false) => new Promise((res) => {
    this.setState({ loading }, () => {
      if (this.props.onLoading) {
        this.props.onLoading(loading);
      }
      res(loading);
    });
  })
  async fetchProjects() {
    const { store } = this.context;
    const query = Object.assign({
      limit: 0,
      showAsOptions: true,
      hims: true,
    });
    await this.setLoadingProjectSearch(true);
    let res;

    try {
      res = await store.dispatch(fetchM(`/projects/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoadingProjectSearch(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      let newProjectOpts = this.state.projectOpts;
      if (data && data.length > 0) {
        newProjectOpts = data.map(d => ({ value: d.id, text: d.name }));
      }

      await this.setState({ projectOpts: newProjectOpts }, () => {
        this.handleFilterProjects(
          null,
          { name: 'projectFilter', value: [newProjectOpts[0].value] },
        );
      });
    }
    await this.setLoadingProjectSearch(false);
  }
  fetchBookings = async (q = {}) => {
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign(q, this.props.where || {});

    let res;
    if (this.props.projectUnitID) {
      query.projectUnitID = this.props.projectUnitID;
    }

    try {
      res = await store.dispatch(fetchM(`/bookings/hims/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const token = res.headers.get('X-Csrf-Token');
      const data = await res.json();
      await this.setBookings(data ? data.map(d => Object.assign({}, d, { isSelected: false })) : []);
      const que = decodeSearch(this.props.location.search);
      const currentPage = parseInt(que.page, 10) || 1;
      if (this.state.data.length < 1 && query.page > 1) {
        que.page = 1;
        this.replaceQuery(que);
      } else {
        await this.setComponentState({
          count,
          token,
        });
      }
      this.getDataByPage(currentPage || 1);
    }
    await this.setLoading(false);
  }
  batchSyncSelectedBookings = async () => {
    await this.setLoading(true);
    const ids = this.state.data.filter(d => d.isSelected).map(d => d.id);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM('/bookings/hims/bulk/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify({ ids }),
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    }
    await this.setLoading(false);

    const que = decodeSearch(this.props.location.search);
    que.page = 1;
    this.replaceQuery(que);

    await store.dispatch(flashSuccessMessage({ message: 'HIMS sync successfully triggered' }));
  }
  handleResize = () => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }
  handleChangePage = (page) => {
    const { limit } = this.state;
    const query = decodeSearch(this.props.location.search);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    const currentPage = parseInt(page || query.page, 10);
    const offset = (currentPage - 1) * limit;
    query.page = currentPage;
    this.setState({ currentPage, offset }, () => {
      this.replaceQuery(query);
    });
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    let clearSearch = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (filter === 'search') {
        clearSearch = true;
      }
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
        this.setState({ isChanging: false });
      }
      if (filter === 'projectFilter') {
        this.setState({
          filteredProjects: [],
        });
      }
    });
    const cb = () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    };
    if (clearSearch) {
      this.setState({ search: '' }, () => {
        cb();
      });
    } else {
      cb();
    }
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    let refetch = queryName !== 'searchIn' || (queryName === 'searchIn' && this.state.search.length > 0);
    if (queryName === 'dateRange' && query.dateRange === 'custom' && (!query.dateFrom || !query.dateTo)) {
      refetch = false;
    }
    this.setState({ isChanging: true });
    this.replaceQuery(query, true, refetch);
  }
  handleSetDateRange = (from, to) => {
    const query = decodeSearch(this.props.location.search);
    query.dateFrom = from;
    query.dateTo = to;
    this.replaceQuery(query, true);
  }
  handleReplaceStatus = (status = '') => {
    const query = decodeSearch(this.props.location.search);
    if (status !== '') {
      query.status = status;
    } else {
      delete query.status;
    }
    this.replaceQuery(query, true, false);
    this.setState({ status }, () => {
      this.getDataByPage(query.page);
    });
  }
  handleFilterProjects = (e, { name, value }) => {
    this.setState({
      filteredProjects: value,
      isChanging: true,
    });
    const query = decodeSearch(this.props.location.search);
    query[name] = btoa(value);
    this.replaceQuery(query, true);
  }
  replaceQuery(query, resetPage = false, fetch = true) {
    const { store } = this.context;
    const { pathname, search } = this.props.location;
    const queryNew = query;
    this.setState({ isSelectedAll: false });
    if (resetPage) {
      queryNew.page = 1;
    }
    const status = decodeSearch(search).status;
    if (query.status && !status) {
      queryNew.page = 1;
    }
    if (fetch) {
      this.fetchBookings(queryNew);
    }
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  exportURL = () => {
    const { location } = this.props;
    let url = `${config.get('bookApiURL')}/bookings/hims/export/`;
    if (location && location.search) {
      url += `${location.search}`;
    }
    return url;
  }
  cellCheckSorted = (column, isReversed = false) => {
    const { sortColumn, sortDirection } = decodeSearch(this.props.location.search);
    // API default sorted by created at descending
    if (!sortColumn) {
      return 'descending';
    }
    if (column === sortColumn) {
      if (isReversed) {
        return sortDirection === 'asc' ? 'descending' : 'ascending';
      }
      return sortDirection === 'asc' ? 'ascending' : 'descending';
    }
    return null;
  }
  handleCellSort = (column) => {
    const { sortColumn, sortDirection } = decodeSearch(this.props.location.search);
    let direction = 'asc';
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    this.handleSortData(column, direction);
  }
  renderMenuTool = () => {
    const { isMobile, loading, loadingProjectSearch, isChanging } = this.state;
    const syncStatuses = [
      { text: 'All', value: 'all', name: 'all' },
      ...HIMS_BOOKING_SYNC_STATUSES,
    ];
    return (
      <Grid.Row className={'toolbar new'}>
        <Grid.Column width={16}>
          <Grid
            className="filters booking"
            columns="equal"
            textAlign="left"
            verticalAlign="middle"
          >
            <Grid.Row>
              <Grid.Column
                className="filter"
                mobile={16}
                tablet={8}
                computer={2}
                style={isMobile ? { marginBottom: '6px' } : null}
              >
                <label htmlFor="status" style={{ fontWeight: 600, marginBottom: '5px', display: 'block' }}>
                  Sync Status
                </label>
                <BookingSelectList
                  filterName="status"
                  onChange={this.handleReplaceStatus}
                  options={syncStatuses}
                  placeholder="Status"
                  value={this.state.status || 'all'}
                  disabled={loading}
                />
              </Grid.Column>
              <Grid.Column
                className="filter"
                mobile={16}
                tablet={8}
                computer={3}
              >
                <label htmlFor="dateRange" style={{ fontWeight: 600, marginBottom: '5px', display: 'block' }}>
                  Date Range
                </label>
                <BookingDatePicker
                  filterName="dateRange"
                  filterNameFrom="dateFrom"
                  filterNameTo="dateTo"
                  headerText="Date Range"
                  placeholder="Select Date Range"
                  dateFrom={this.state.dateFrom}
                  dateTo={this.state.dateTo}
                  onChange={this.handleFilterOnChange}
                  onClose={this.handleClearFilter}
                  onResetRange={this.handleClearFilter}
                  onSetRange={this.handleSetDateRange}
                  value={this.state.dateRange}
                  disabled={loading}
                />
              </Grid.Column>
              <Grid.Column
                className="filter"
                mobile={isChanging ? 14 : 16}
                tablet={isChanging ? 7 : 8}
                computer={6}
                style={isMobile ? { paddingTop: '0.5rem' } : null}
              >
                <label htmlFor="projectFilter" style={{ fontWeight: 600, marginBottom: '5px', display: 'block' }}>
                  Project
                </label>
                <Dropdown
                  disabled={loading || loadingProjectSearch}
                  fluid
                  loading={loadingProjectSearch}
                  multiple
                  name="projectFilter"
                  onChange={this.handleFilterProjects}
                  options={this.state.projectOpts}
                  placeholder="Find Project"
                  search
                  selection
                  value={this.state.filteredProjects}
                />
              </Grid.Column>
              <Grid.Column
                className="clear"
                textAlign="center"
                verticalAlign="middle"
                mobile={2}
                tablet={1}
                computer={1}
                style={{ marginTop: '20px' }}
              >
                {
                  allFilterNames.some(filterName => this.state[filterName] &&
                  this.state[filterName].length > 0) ? (
                    <a onClick={() => this.handleClearFilter(...allFilterNames)}>
                      <Button icon basic className="teal-remove">
                        <Icon name="remove circle" size="large" />
                      </Button>
                    </a>
                  ) : null
                }
              </Grid.Column>
              <Grid.Column
                floated="right"
                mobile={16}
                tablet={8}
                computer={4}
              >
                <label htmlFor="search" style={{ fontWeight: 600, marginBottom: '5px', display: 'block' }}>
                  Search
                </label>
                <SearchIn
                  isLoading={loading}
                  onChange={this.handleFilterOnChange}
                  onSearchInChange={this.handleFilterOnChange}
                  onClear={this.handleClearFilter}
                  search={this.state.search}
                  placeholder="Search by unit & purchaser"
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid.Row>
    );
  }
  renderMobileCell = data => (
    <Grid
      columns="equal"
      verticalAlign="middle"
    >
      <Grid.Column textAlign="center" mobile={2}>
        <Checkbox
          checked={data.isSelected}
          name="isSelected"
          disabled={!this.isBookingSelectable(data)}
        />
      </Grid.Column>
      <Grid.Column>
        <Link title={data.code} to={`/bookings/${data.id}/`}>
          {data.bookingCustomer && data.bookingCustomer.name}
        </Link>
        <Grid.Column>
          <Link title={data.code} to={`/bookings/${data.id}/`} style={{ fontWeight: 'normal' }}>
            {data.projectUnit.reference}, {data.project.shortName}
          </Link>
        </Grid.Column>
        <Grid.Column style={{ fontWeight: 'normal' }}>
          <small>
            {data.bookingStatus ? data.bookingStatus.name : ''} -
            <Link
              onClick={e => this.handleOpenErrorModal(e, {
                httpStatus: data.himsServiceHttpStatus,
                response: data.himsServiceResponse,
                action: data.himsServiceAction,
                errors: data.himsServiceErrors,
              })}
            >
              {titleCase(data.himsServiceStatus) || 'Pending Sync'}
              {(!data.himsServiceID || data.himsHasChanges) && data.himsServiceStatus !== '' &&
              <Label size="mini" style={{ marginLeft: '0.5em', backgroundColor: '#e6fff2', color: '#008040' }}>Pending Sync</Label>}
            </Link>
          </small>
        </Grid.Column>
        <small style={{ fontWeight: 'normal' }}>
          <Timestamp
            timestamp={data.createdAt}
            format="DD/M/YYYY"
          />
        </small>
      </Grid.Column>
      <Link to={`/bookings/${data.booking_id}/`}>
        <Icon name="chevron right" style={{ float: 'right' }} />
      </Link>
    </Grid>
  );
  renderTableHeaders = (sortItems) => {
    const { data } = this.state;
    return (
      <Table.Header className="mobile-hide">
        <Table.Row>
          <Table.HeaderCell
            onClick={(e) => {
              if (data.length > 0) this.handleCheckboxSelectAll(e);
            }}
          >
            <Checkbox
              checked={this.state.isSelectedAll}
              disabled={data.length < 1}
            />
          </Table.HeaderCell>
          <Table.HeaderCell collapsing>Status</Table.HeaderCell>
          <Table.HeaderCell
            collapsing
            sorted={this.cellCheckSorted(sortItems[3].sortColumn)}
            onClick={() => this.handleCellSort(sortItems[3].sortColumn)}
          >
            Created
          </Table.HeaderCell>
          <Table.HeaderCell>Last Sync</Table.HeaderCell>
          <Table.HeaderCell>Unit</Table.HeaderCell>
          <Table.HeaderCell>Booking status</Table.HeaderCell>
          <Table.HeaderCell>Customer</Table.HeaderCell>
          <Table.HeaderCell>Reserved by</Table.HeaderCell>
          <Table.HeaderCell />
        </Table.Row>
      </Table.Header>
    );
  }
  renderTableRow = (data, idx) => {
    const himsStatus = titleCase(data.himsServiceStatus) || 'Pending Sync';
    const disabled = !this.isBookingSelectable(data);
    return (
      <Table.Row key={idx}>
        <Table.Cell
          onClick={e => this.handleCheckboxClick(e, data)}
          className="clickable computer-hide"
          disabled={disabled}
        >
          {this.renderMobileCell(data)}
        </Table.Cell>
        <Table.Cell
          onClick={e => this.handleCheckboxClick(e, data)}
          className="clickable mobile-hide"
          disabled={disabled}
        >
          <Checkbox
            checked={data.isSelected}
            name="isSelected"
            disabled={disabled}
          />
        </Table.Cell>
        <Table.Cell collapsing className="mobile-hide">
          {data.himsServiceErrors && data.himsServiceErrors.length > 0 ? (
            <Link
              onClick={e => this.handleOpenErrorModal(e, {
                httpStatus: data.himsServiceHttpStatus,
                response: data.himsServiceResponse,
                action: data.himsServiceAction,
                errors: data.himsServiceErrors,
              })}
            >
              {himsStatus}
            </Link>
          ) : himsStatus}
          {(!data.himsServiceID || data.himsHasChanges) && data.himsServiceStatus &&
            <Label size="mini" style={{ marginLeft: '0.5em', backgroundColor: '#e6fff2', color: '#008040' }}>Pending Sync</Label>}
        </Table.Cell>
        <Table.Cell collapsing className="mobile-hide">
          <Timestamp
            timestamp={data.createdAt}
            format="DD/M/YYYY"
          />
        </Table.Cell>
        <Table.Cell className="mobile-hide">
          {data.himsServiceUpdatedAt ? (
            <Timestamp
              timestamp={data.himsServiceUpdatedAt}
              format="DD/M/YYYY"
            />
          ) : '-'}
        </Table.Cell>
        <Table.Cell className="mobile-hide">
          <Link title={data.code} to={`/bookings/${data.id}/`}>
            {data.projectUnit.reference}, {data.project.shortName}
          </Link>
        </Table.Cell>
        <Table.Cell className="mobile-hide">
          {data.bookingStatus ? data.bookingStatus.name : ''}
        </Table.Cell>
        <Table.Cell className="mobile-hide">
          <Link title={data.code} to={`/bookings/${data.id}/`}>
            {data.bookingCustomer && data.bookingCustomer.name}
          </Link>
        </Table.Cell>
        <Table.Cell collapsing textAlign="left" className="mobile-hide">
          <Link to={`/users/${data.maUserAffiliateID}/`}>
            {data.maCreatedByPreferredName}
          </Link>
        </Table.Cell>
        <Table.Cell collapsing className="mobile-hide">
          <Link to={`/bookings/${data.id}/`}>
            <Icon name="chevron right" />
          </Link>
        </Table.Cell>
      </Table.Row>
    );
  }
  render() {
    const { loading, dataByStatus, isMobile, errorModalOpen, himsErrorLog } = this.state;
    const sortItems = [
      {
        text: 'Unit Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'project_unit.reference',
        sortDirection: 'asc',
      },
      {
        text: 'Unit Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'project_unit.reference',
        sortDirection: 'desc',
      },
      {
        text: 'Date Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'booking.created_at',
        sortDirection: 'asc',
      },
      {
        text: 'Date Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'booking.created_at',
        sortDirection: 'desc',
      },
      {
        text: 'Booking Status Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'booking_status.name',
        sortDirection: 'asc',
      },
      {
        text: 'Booking Status Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'booking_status.name',
        sortDirection: 'desc',
      },
    ];
    const exportItems = [
      {
        text: 'Excel',
        icon: 'download',
        href: this.exportURL(),
      },
    ];
    return (
      <Grid verticalAlign="middle" className="booking-list">
        <ModalNotice
          open={errorModalOpen}
          onClose={this.handleCloseErrorModal}
          headerNode="HIMS Error Logs"
          content={himsErrorLog ? (
            <HimsErrorLog
              {...himsErrorLog}
            />
          ) : ''}
        />
        {this.renderMenuTool()}

        {/* List Data */}
        <Grid.Row className="app--listdata">
          <Grid.Column>
            <Dimmer
              inverted style={{ zIndex: 20 }}
              active={loading && dataByStatus.length > 0}
            >
              <Loader inline="centered">Loading</Loader>
            </Dimmer>
            <Grid className="booking-data" columns="equal" verticalAlign="middle">
              <Grid.Row className="header">
                {isMobile &&
                  <Grid.Column textAlign="center" mobile={2}>
                    <Checkbox
                      checked={this.state.isSelectedAll}
                      disabled={dataByStatus.length < 1}
                      onChange={(e) => {
                        if (dataByStatus.length > 0) this.handleCheckboxSelectAll(e);
                      }}
                    />
                  </Grid.Column>
                }
                <Grid.Column mobile={7} tablet={6} computer={6}>
                  <Header as="h2">Latest Bookings</Header>
                </Grid.Column>
                <Grid.Column mobile={7} tablet={10} computer={10} textAlign="right" className="download">
                  <Button
                    floated="right"
                    style={{ marginLeft: '0.5em' }}
                    primary
                    icon={isMobile}
                    disabled={this.state.loading || !dataByStatus.some(b => b.isSelected)}
                    onClick={this.batchSyncSelectedBookings}
                  >
                    <Icon name="redo" />
                    {!isMobile && 'Sync to HIMS'}
                  </Button>
                  <SortButton
                    floated="right"
                    loading={loading}
                    items={sortItems}
                    onSort={this.handleSortData}
                  />
                  {
                    exportItems.length > 0 && (
                      <SortButton
                        floated="right"
                        icon="download"
                        loading={loading}
                        items={exportItems}
                      />
                    )
                  }
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <Table basic="very" sortable className="hims_bookings">
                    {this.renderTableHeaders(sortItems)}
                    <Table.Body>
                      {
                        dataByStatus.length > 0 ?
                          dataByStatus.map(this.renderTableRow) : (
                            <Table.Row>
                              <Table.Cell colSpan={10} textAlign="center">
                                {
                                  loading ?
                                    <Loader active inline="centered">Loading</Loader>
                                  : <p>No bookings found.</p>
                                }
                              </Table.Cell>
                            </Table.Row>
                          )
                      }
                    </Table.Body>
                  </Table>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <PageNav
              upward
              currentPage={this.state.currentPage}
              count={this.state.count}
              limit={this.state.limit}
              offset={this.state.offset}
              dataSize={dataByStatus.length}
              loading={loading}
              onChange={this.handleChangePage}
              noScrollTop={this.props.noScrollTop}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withRouter(HIMSBookingsList);



// WEBPACK FOOTER //
// ./src/components/HIMSBookingsList.jsx